<!--公用组件：蓝湖app客服页面
    @dengli
    @date 2018.3.25
    - 通过iframe引入的创客云客服聊天页面
-->
<template>
  <div class="kefu-wrapper">
    <title-bar title="蓝湖客服"></title-bar>
    <div class="kefu-iframe">
      <iframe
        class="lanhu-kefu"
        marginheight="4.5rem"
        src="https://lanhu.kf5.com/kchat"
        frameborder="0"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.kefu-wrapper {
    width: 100%;
    height: 100vh;
    .kefu-iframe {
        position: relative;
        bottom: 0;
        overflow: hidden;
        width: 100%;
        height: 100%;
        .lanhu-kefu {
            position: absolute;
            width: 100%;
            box-sizing: border-box;
            height: 100%;
            padding-top: 3.35rem;
            bottom: 0;
        }
    }
}
</style>
<script>
import titleBar from "../layout/TitleBar"
export default {
    name: "Kefu",
    components: {
        titleBar
    },
    created() {
        this.$root.eventBus.$emit("showLoading")
    },
    mounted() {
        var _this = this
        var myFrame = document.querySelector(".lanhu-kefu")
        myFrame.onload = function() {
            _this.$root.eventBus.$emit("hideLoading")
        }
    }
}
</script>


